import { render, staticRenderFns } from "./InterventionButton.vue?vue&type=template&id=21571e5f&"
import script from "./InterventionButton.vue?vue&type=script&lang=js&"
export * from "./InterventionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports